/*
 ___ _
| _ \ |__ _ _  _ ___ _ _
|  _/ / _` | || / -_) '_|
|_| |_\__,_|\_, \___|_|
            |__/         */

import { Vec2 } from './vector';
import { Effect } from '@/game/effect';
import { PlayerOptions } from '.';

export class Player {

  public id: number;
  public width: number;
  public color: string;
  public gameWidth: number;

  public index = 0;
  public pos = 0;
  public name = '';
  public points = 0;
  public isBot = false;
  private direction = 'stop';

  public middlePoint!: Vec2;
  public tangent!: Vec2;
  public rotation: number = 0;

  public keys!: { left: string, right: string };

  private velocities = {
    left: -100,
    right: 100,
  }; // in pixel/s

  public effects: Effect[] = [];
  private effectId = 0;

  constructor(id: number, width: number, options: PlayerOptions, gameWidth: number) {
    this.id = id;
    this.width = width;
    this.color = options.color;
    this.keys = options.keys;
    this.name = options.name;
    this.isBot = options.isBot;
    this.gameWidth = gameWidth;
  }

  public calcRotation(count: number) {
    let deg = ((360 + 360 * this.index / count) % 360);
    let rad = Math.PI*deg/180 + Math.PI/2;
    let innerRadius = this.gameWidth/2 * Math.cos(Math.PI/count)/Math.sin(Math.PI/count);
    this.middlePoint = new Vec2(Math.cos(rad),Math.sin(rad));
    this.middlePoint.multiplyScalar(innerRadius);
    this.tangent = new Vec2(-Math.sin(rad),Math.cos(rad));
    this.rotation = deg;
  }

  public setUsername(name: string) {
    this.name = name;
  }

  public setPosition(pos: number) {
    // console.log('setPosition', pos, this.id);
    let max = (this.gameWidth - this.width) / 2;
    this.pos = Math.max(Math.min(pos, max), -max);
  }

  public updatePosition(dt: number) {
    switch (this.direction) {
      case 'left':
        this.setPosition(this.pos + this.velocities.left * dt);
        break;
      case 'right':
        this.setPosition(this.pos + this.velocities.right * dt);
        break;
    }
  }

  public setDirection(d: 'left' | 'right' | 'stop') {
    if (d !== 'left' && d !== 'right') { this.direction = 'stop'; }
    else { this.direction = d; }
  }

  public applyEffect(effect: Effect) {
    effect.id = this.effectId++;
    this.effects.push(effect);

    if (effect.width) { this.width *= effect.width; }
    if (effect.speedLeft) { this.velocities.left *= effect.speedLeft; }
    if (effect.speedRight) { this.velocities.right *= effect.speedRight; }

    if (effect.duration > 0) {
      setTimeout(() => {
        this.effects.splice(this.effects.findIndex(el => el.id === effect.id), 1);
        if (effect.width) { this.width /= effect.width; }
        if (effect.speedLeft) { this.velocities.left /= effect.speedLeft; }
        if (effect.speedRight) { this.velocities.right /= effect.speedRight; }
      }, effect.duration);
    }
  }

  public getJSON() {
    return {
      name: this.name,
      id: this.id,
      color: this.color,
      points: this.points,
    };
  }
}
